module.exports = __webpack_public_path__ + "static/media/dashboard.50ccd510.svg";